import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialProjectsStatusesState = {};

const projectsStatusesSlice = createSlice({
  name: "projectsStatuses",
  initialState: initialProjectsStatusesState,
  reducers: {
    setProjectsStatusesData: (_state: any, action: PayloadAction<any>) =>
      action.payload.reduce((prev: Record<string, any>, curr: any) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setProjectsStatusesData } = projectsStatusesSlice.actions;

export const projectsStatuses = projectsStatusesSlice.reducer;

export default projectsStatusesSlice.reducer;
